/**
 * Caller RBAC access profile, fetched once in AppLayout and shared via context.
 * Restricted Developer-only viewers are gated in the sidebar (nav), AppLayout (route redirect),
 * and DateRangeDropdown (≤maxRangeDays clamp). Backend enforces the same rules authoritatively.
 */
import { createContext, useContext } from 'react'
import type { AccessProfile } from '@system/shared'

export const DEFAULT_ACCESS: AccessProfile = {
  isAdmin: false, isDevRestricted: false, reportOnly: false, monetOnly: false, maxRangeDays: null, hideCosts: false,
  eCode: null, isEmployee: false, isUa: false, isDa: false, canLocalize: false, canCreativeSpy: false, canGadsEditor: false, canAdmobBlock: false, isMonet: false, isDev: false, isQa: false, hasDevApps: false, isHr: false, isHrLead: false, isCto: false, isCmo: false, isDesignLead: false, isMonetLead: false, isAso: false, canMonetAssign: false,
  canReadCommission: false, canReadUaLeaderboard: false, isGameOperator: false, isGamePlayer: false,
  disabledNav: [], canToggleNav: false, pageGrants: [], pageBlocks: [],
  canMoLead: false,
}

export const AccessContext = createContext<AccessProfile>(DEFAULT_ACCESS)

export const useAccess = (): AccessProfile => useContext(AccessContext)
